import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api, apiErrorMessage } from '@lipaflow/shared'
import toast from 'react-hot-toast'
import type { StepProps } from '../types'

/** Step 3: set up their trial. Its days start when they go live, as for a customer who signs up themselves. */
export default function SetupSubscriptionStep({ tenantId }: StepProps) {
  const queryClient = useQueryClient()

  const activateMutation = useMutation({
    mutationFn: async () => {
      await api.post('/admin/wizard/setup-subscription', { tenant_id: tenantId })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-wizard', tenantId] })
      toast.success('Trial set up. Its 14 days start when they go live.')
    },
    onError: (err: unknown) => {
      toast.error(apiErrorMessage(err, 'Failed to activate trial'))
    },
  })

  return (
    <div className="text-center">
      <h2 className="text-xl font-semibold mb-4">Step 3: Set up their trial</h2>
      <div className="bg-accent-soft rounded-button p-6 mb-6">
        <h3 className="text-lg font-medium text-accent">Free trial</h3>
        <p className="text-3xl font-bold text-accent my-2">14 days</p>
        <p className="text-accent">Everything included. The days start when they go live, so setting up costs them none.</p>
      </div>
      <button
        onClick={() => activateMutation.mutate()}
        disabled={activateMutation.isPending}
        className="px-8 py-3 bg-accent text-on-accent rounded-button hover:bg-accent-hover disabled:opacity-50 text-lg"
      >
        {activateMutation.isPending ? 'Setting up…' : 'Set up the trial'}
      </button>
    </div>
  )
}
